import React from 'react'

import FontFile from '../shared/font-file'

const Word = (props) => {
  return <FontFile font={'casual'} multiplier={1.4} {...props} />
}

export default Word
